// FICHIER GENERE — ne pas modifier a la main.
// Source : src/AppRoutes.tsx  ·  Regeneration : node scripts/generer-permissions-routes.js
//
// Permission exigee par chaque route protegee. Sert au menu lateral pour
// masquer les entrees inaccessibles, sans avoir a redeclarer le droit dans
// le composant de navigation.
// Valeur 'a|b' : route ouverte a qui detient AU MOINS UN de ces droits
// (requiredAnyPermission) — tester avec aDroitRoute().

export const PERMISSION_PAR_ROUTE: Record<string, string> = {
  '/accords-commerciaux': 'access_recouvrement|gerer_recouvrement_eau', // eau — P2 recouvrement & clientèle
  '/achats': 'access_achats',
  '/achats/cotations/:id': 'access_achats',
  '/adherents/:id/vue-360': 'access_suivi_cotisations|admin_users',
  '/adherents/cotisations': 'access_suivi_cotisations|admin_users',
  '/adherents/etats': 'access_suivi_cotisations|access_gestion_adherents|admin_users',
  '/admin/bancaire-reconciliation': 'access_finances',
  '/admin/baremes-frais-entree': 'authenticated',
  '/admin/bridge': 'manage_bridge|access_interfacage',
  '/admin/cinetpay/historique': 'access_admin',
  '/admin/conventions-subvention': 'authenticated',
  '/admin/coupures': 'access_admin',
  '/admin/demandes-client': 'authenticated',
  '/admin/dev/modules': 'access_admin',
  '/admin/dev/types-operation': 'access_admin',
  '/admin/dev/types-operation/:code': 'access_admin',
  '/admin/form-templates': 'access_admin',
  '/admin/referentiel-devises': 'access_admin',
  '/admin/referentiels': 'access_admin',
  '/admin/templates-documents': 'access_admin',
  '/administration': 'access_admin',
  '/administration/alertes': 'access_admin',
  '/administration/axes-analytiques': 'access_admin',
  '/administration/espace-client': 'access_espace_client_admin',
  '/administration/referentiels-fiscaux': 'access_admin',
  '/agregateur': 'access_agregateur_paiement',
  '/alertes': 'access_alertes',
  '/assurance': 'access_assurance',
  '/assurance/dashboard': 'view_stats_assurance',
  '/bilan-periodique': 'access_statistics',
  '/bordereaux-intervention/:id': 'access_electricite',
  '/boutique/commandes-en-ligne': 'gerer_commandes_enligne',
  '/boutique/coursiers': 'gerer_commandes_enligne',
  '/boutique/statistiques-livraison': 'gerer_commandes_enligne',
  '/boutique/suivi-livraisons': 'gerer_commandes_enligne',
  '/boutique/zones-livraison': 'gerer_commandes_enligne',
  '/caisse': 'access_caisse',
  '/caisse/annulation': 'access_caisse',
  '/caisse/billetage': 'access_caisse',
  '/caisse/billetages/historique': 'access_caisse',
  '/caisse/ecarts': 'access_caisse',
  '/caisse/etats': 'access_caisse',
  '/caisse/legacy': 'access_caisse',
  '/caisse/paiement-salaires': 'access_caisse',
  '/caisse/reedition': 'access_caisse',
  '/caisse/remise-banque': 'access_caisse',
  '/caisse/remises': 'access_caisse',
  '/caisse/scolarite': 'access_caisse',
  '/caisse/validation-annulations': 'valider_annulation_encaissement',
  '/chantiers': 'access_chantier',
  '/chantiers/marches': 'access_chantier|gerer_marches_btp|admin_btp',
  '/chantiers/marches/:id': 'access_chantier|gerer_marches_btp|admin_btp',
  '/chantiers/parametrage-btp': 'parametrer_btp|admin_btp',
  '/chantiers/situations/:id': 'access_chantier|gerer_marches_btp|saisir_situation_btp|valider_situation_btp|facturer_situation_btp|admin_btp',
  '/clients': 'access_clients',
  '/clients/:id/vue-360': 'authenticated',
  '/comptabilite': 'access_comptabilite',
  '/comptabilite/rebalance': 'access_rebalance_ecritures',
  '/conflits-interet': 'declarer_conflit_interet',
  '/consignation': 'access_consignation',
  '/consolidation': 'access_consolidation_groupe',
  '/consolidation-electricite': 'access_consolidation_electricite',
  '/contacts': 'access_contacts',
  '/crm': 'access_clients|voir_dashboard_crm',
  '/crm/abonnements': 'access_abonnements',
  '/crm/acquisition': 'access_crm',
  '/crm/branchements': 'access_branchements',
  '/crm/clients/:clientId/fiche': 'access_clients',
  '/crm/dossiers-vente': 'access_dossiers_vente',
  '/crm/dossiers-vente/:id': 'access_dossiers_vente',
  '/crm/dossiers-vente/mes-actions': 'access_dossiers_vente',
  '/crm/engagement': 'access_crm',
  '/crm/enquetes-satisfaction': 'access_demandes_client',
  '/crm/enquetes-satisfaction/bilan': 'access_demandes_client',
  '/crm/enquetes-satisfaction/suivi-actions': 'access_demandes_client',
  '/crm/etat-activite': 'voir_etat_activite_crm',
  '/crm/etats': 'voir_etats_crm',
  '/crm/fidelite': 'access_crm',
  '/crm/objectifs': 'gerer_objectifs_crm',
  '/crm/pipeline': 'access_crm',
  '/crm/planning': 'access_planning_activite',
  '/crm/prospects': 'access_prospects',
  '/crm/rapports': 'access_clients',
  '/crm/rapports-a-valider': 'valider_rapport_crm',
  '/crm/rapports/:id': 'access_clients',
  '/crm/rapports/:id/modifier': 'access_clients',
  '/crm/rapports/nouveau': 'access_clients',
  '/crm/reclamations': 'access_reclamations',
  '/crm/reclamations/bareme-etalonnage': 'gerer_frais_etalonnage',
  '/crm/retention': 'access_crm',
  '/dashboard': 'access_dashboard',
  '/db-sync': 'access_db_sync',
  '/decaissements-directs': 'access_decaissements',
  '/decaissements-directs/:id': 'access_decaissements',
  '/decaissements-directs/:id/print': 'access_decaissements',
  '/decaissements-directs/export': 'access_decaissements',
  '/decaissements-directs/nouveau': 'access_decaissements',
  '/decaissements/paiement-fournisseur': 'access_decaissements',
  '/decaissements/paiement-prestataire': 'access_decaissements',
  '/decaissements/paiement-tous': 'access_decaissements',
  '/demandes-decaissement': 'access_decaissements',
  '/demandes-decaissement/:id': 'access_decaissements',
  '/demandes-decaissement/modifier/:id': 'access_decaissements',
  '/demandes-decaissement/nouveau': 'access_decaissements',
  '/demandes-decaissement/paiement/:id': 'access_decaissements',
  '/demandes-decaissement/statistiques': 'access_decaissements',
  '/demandes-decaissement/validation/:id': 'access_decaissements',
  '/demandes-remboursement': 'access_demande_remboursement',
  '/devis': 'access_clients',
  '/dividendes/distributions': 'view_dividendes',
  '/eau': 'access_eau',
  '/eau/antennes-privees': 'access_eau|gerer_antennes_privees_eau',
  '/eau/bornes-fontaines': 'access_eau|gerer_bornes_fontaines_eau',
  '/eau/caisse': 'access_eau|access_caisse|operations_diverses_eau|gerer_remboursements_eau|access_facturation_eau|valider_operations_diverses_eau', // eau — suites
  '/eau/contrats-compteurs': 'access_eau|access_facturation_eau',
  '/eau/etats': 'access_etats_eau',
  '/eau/immeubles': 'access_eau|gerer_immeubles_eau',
  '/eau/pertes': 'access_pertes_eau',
  '/edition': 'access_edition',
  '/elearning/cours/:id': 'access_elearning',
  '/elearning/formateur': 'gerer_elearning',
  '/elearning/formateur/cours/:id': 'gerer_elearning',
  '/elearning/mes-formations': 'access_elearning',
  '/elearning/suivi': 'gerer_elearning',
  '/electricite': 'access_electricite',
  '/espace-adherent': 'authenticated',
  '/evaluation-performance': 'access_evaluation_performance',
  '/facturation-eau': 'access_facturation_eau',
  '/facturation-electrique': 'access_facturation_electrique',
  '/facturation-electrique/bt': 'access_facturation_electrique',
  '/facturation-electrique/bt/:cycleId': 'access_facturation_electrique',
  '/facturation-electrique/calendrier': 'access_facturation_electrique',
  '/facturation-electrique/compteurs-intelligents': 'access_facturation_electrique',
  '/facturation-electrique/mt': 'access_facturation_electrique',
  '/facturation-electrique/mt/:cycleId': 'access_facturation_electrique',
  '/facturation-electrique/prepaye': 'access_facturation_electrique',
  '/factures-fournisseur': 'access_factures_fournisseur',
  '/factures-fournisseur/:id': 'access_factures_fournisseur',
  '/factures-fournisseur/:id/modifier': 'gerer_factures_fournisseur',
  '/factures-fournisseur/a-rapprocher': 'access_factures_fournisseur',
  '/factures-fournisseur/nouvelle': 'gerer_factures_fournisseur',
  '/federation': 'access_federation|gerer_mon_club|instruire_ligue|gerer_federation',
  '/federation/agrements': 'access_federation|gerer_mon_club|instruire_ligue|gerer_federation|gerer_agrements_federation',
  '/federation/clubs': 'access_federation|gerer_mon_club|instruire_ligue|gerer_federation',
  '/federation/commissions': 'access_federation|gerer_federation|gerer_commissions_federation',
  '/federation/evenements': 'access_federation|instruire_ligue|gerer_federation',
  '/federation/licences': 'access_federation|gerer_mon_club|instruire_ligue|gerer_federation',
  '/federation/paiements': 'access_federation|gerer_mon_club|encaisser_federation|gerer_federation',
  '/federation/parametrage': 'parametrer_federation',
  '/federation/structures': 'access_federation|gerer_mon_club|instruire_ligue|gerer_federation',
  '/federation/suivi-affiliations': 'access_federation|instruire_ligue|gerer_federation|encaisser_federation',
  '/finances/cash-pooling': 'manage_cash_pooling',
  '/finances/couverture-change': 'manage_couverture_change',
  '/fonds-epargne': 'access_fonds_epargne',
  '/gmao/carte': 'access_gmao|declarer_incident_reseau|gerer_ordres_travail|executer_ordres_travail',
  '/gmao/coupures-programmees': 'access_gmao|planifier_coupures_eau',
  '/gmao/equipes': 'access_gmao|gerer_equipes_gmao|gerer_ordres_travail|parametrer_gmao',
  '/gmao/incidents': 'access_gmao|declarer_incident_reseau|gerer_ordres_travail|executer_ordres_travail',
  '/gmao/indicateurs': 'access_gmao|voir_indicateurs_gmao|gerer_ordres_travail|parametrer_gmao',
  '/gmao/ordres-travail': 'access_gmao|gerer_ordres_travail|executer_ordres_travail|declarer_incident_reseau',
  '/gmao/patrimoine': 'access_gmao|gerer_patrimoine_reseau|parametrer_gmao',
  '/gmao/preventif': 'access_gmao|gerer_maintenance_preventive|gerer_ordres_travail|parametrer_gmao',
  '/gmao/qualite-eau': 'access_gmao|gerer_qualite_eau',
  '/gmao/terrain': 'access_gmao|executer_ordres_travail|declarer_incident_reseau|gerer_ordres_travail',
  '/gouvernance': 'access_gouvernance',
  '/immobilier': 'access_immobilier',
  '/immobilier/dashboard-consolide': 'access_immobilier',
  '/immobilisations': 'access_immobilisations',
  '/immobilisations/cartographie': 'access_immobilisations',
  '/immobilisations/cloture': 'access_immobilisations',
  '/immobilisations/credit-bail': 'access_immobilisations',
  '/immobilisations/etats': 'access_immobilisations',
  '/immobilisations/garanties': 'access_immobilisations',
  '/immobilisations/integrite': 'access_immobilisations',
  '/immobilisations/inventaires': 'access_immobilisations',
  '/immobilisations/inventaires/:id': 'access_immobilisations',
  '/immobilisations/maintenance': 'access_immobilisations',
  '/immobilisations/subventions': 'access_immobilisations',
  '/inventaire': 'access_inventaire',
  '/location': 'access_location',
  '/mode-couture': 'access_mode_couture',
  '/mon-espace/achats': 'authenticated',
  '/mon-espace/acompte': 'authenticated',
  '/mon-espace/acomptes': 'authenticated',
  '/mon-espace/bulletins': 'authenticated',
  '/mon-espace/demission': 'authenticated',
  '/mon-espace/evaluations': 'authenticated',
  '/mon-espace/ma-carriere': 'authenticated',
  '/mon-espace/ma-fiche': 'authenticated',
  '/mon-espace/ma-fiche-de-poste': 'authenticated',
  '/mon-espace/ma-fiche/modifier': 'authenticated',
  '/mon-espace/mes-demandes': 'authenticated',
  '/mon-espace/mes-enquetes': 'authenticated',
  '/mon-espace/mes-objectifs': 'authenticated',
  '/mon-espace/mon-cv': 'authenticated',
  '/mon-espace/pret': 'authenticated',
  '/mon-espace/prets': 'authenticated',
  '/niveaux-organisation': 'gerer_niveaux_organisation',
  '/parametrage/banques': 'access_admin',
  '/parametrage/baremes-mission': 'access_baremes_mission',
  '/parametrage/cours-devises': 'access_cours_devises',
  '/parametrage/fne': 'access_fne',
  '/parametrage/menus': 'personnaliser_menus',
  '/parametrage/operateurs-mobile-money': 'access_admin',
  '/parametrage/pieces-requises': 'access_form_templates',
  '/parametrage/regroupements': 'gerer_regroupements',
  '/parametrage/relance-referentiels': 'access_admin',
  '/parametrage/tarifs-eau': 'gerer_tarifs_eau',
  '/parametrage/tarifs-electriques': 'gerer_tarifs_electriques',
  '/pharmacie/bordereaux': 'valider_bordereau_tp',
  '/pharmacie/bordereaux/:id': 'valider_bordereau_tp',
  '/pharmacie/comptoir': 'vente_pharmacie',
  '/pharmacie/registre-stupefiants': 'gerer_registre_stupefiants',
  '/pharmacie/tiers-payant': 'gerer_tiers_payant',
  '/pilotage': 'access_pilotage',
  '/plantation/*': 'access_plantation',
  '/prestations': 'access_achats|access_caisse',
  '/profil': 'authenticated',
  '/promotions/*': 'access_promotions',
  '/prospects': 'access_prospects',
  '/recouvrement': 'access_facturation_electrique',
  '/recouvrement-eau': 'gerer_recouvrement_eau',
  '/rh/absences': 'authenticated',
  '/rh/absences/nouvelle': 'authenticated',
  '/rh/alertes': 'access_rh',
  '/rh/annonces': 'access_annonces_rh',
  '/rh/assermentations': 'view_dossier_employe',
  '/rh/avancements': 'proposer_avancement',
  '/rh/bordereaux-journaliers': 'access_rh',
  '/rh/bordereaux-stages': 'access_rh',
  '/rh/campagnes-primes': 'access_rh',
  '/rh/conformite-dossiers': 'acces_conformite_dossier|gerer_campagnes_documents|access_employes',
  '/rh/conges': 'authenticated',
  '/rh/conges/calendrier': 'view_calendrier_conges',
  '/rh/conges/nouveau': 'authenticated',
  '/rh/conges/validation': 'validate_conge',
  '/rh/contrats': 'access_contrats',
  '/rh/contrats/:id': 'access_contrats',
  '/rh/contrats/:id/modifier': 'create_contrat',
  '/rh/contrats/import': 'import_contrat_rh',
  '/rh/contrats/nouveau': 'create_contrat',
  '/rh/dashboard': 'access_rh',
  '/rh/delegations': 'access_rh',
  '/rh/demandes': 'access_rh',
  '/rh/demandes-documents': 'access_demandes_documents',
  '/rh/demissions': 'access_demission',
  '/rh/disciplinaire': 'manage_rh_params',
  '/rh/disponibilite': 'access_disponibilite',
  '/rh/distinctions': 'proposer_distinction',
  '/rh/documents-entreprise': 'access_documents_entreprise',
  '/rh/employes': 'access_employes',
  '/rh/employes/:id': 'access_employes',
  '/rh/employes/:id/modifier': 'edit_employe',
  '/rh/employes/nouveau': 'create_employe',
  '/rh/enquetes': 'access_enquetes_rh',
  '/rh/etats': 'access_rh',
  '/rh/evaluations': 'access_evaluations_rh',
  '/rh/evaluations/:id': 'access_evaluations_rh',
  '/rh/evaluations/nouveau': 'create_evaluation_rh',
  '/rh/evenements': 'access_evenements_rh',
  '/rh/formations': 'authenticated',
  '/rh/formations/:id': 'authenticated',
  '/rh/formations/:id/inscriptions': 'manage_inscriptions',
  '/rh/formations/nouveau': 'authenticated',
  '/rh/gpec/etats': 'access_rh',
  '/rh/gpec/feedback-360': 'access_rh',
  '/rh/gpec/fiches-postes': 'access_rh',
  '/rh/gpec/matrice-competences': 'access_rh',
  '/rh/gpec/mobilite-interne': 'access_rh',
  '/rh/gpec/profils-carriere': 'access_rh',
  '/rh/gpec/risques': 'access_risques_rh',
  '/rh/gpec/succession': 'access_rh',
  '/rh/gpec/talents': 'access_gpec_talents',
  '/rh/medical': 'access_dossier_medical|acces_medecine_travail',
  '/rh/medical/arrets': 'authenticated',
  '/rh/medical/dossier/:employeId': 'access_dossier_medical|acces_medecine_travail',
  '/rh/medical/mon-dossier': 'authenticated',
  '/rh/mesures': 'access_disciplinaire',
  '/rh/organisation': 'access_rh',
  '/rh/organisation/postes/:id': 'access_rh',
  '/rh/organisation/postes/nouveau': 'access_rh',
  '/rh/organismes-sociaux': 'access_rh',
  '/rh/paie': 'access_paie',
  '/rh/paie/bordereau-paiement': 'access_paie',
  '/rh/paie/bulletin/:id': 'access_paie',
  '/rh/paie/bulletin/:id/edit': 'access_paie',
  '/rh/paie/ecritures-comptables': 'access_paie',
  '/rh/paie/generation': 'generate_paie',
  '/rh/paie/historique': 'access_paie',
  '/rh/parametres': 'manage_rh_params',
  '/rh/pointage': 'access_rh',
  '/rh/recrutement': 'access_recrutement',
  '/rh/recrutement/candidatures': 'manage_candidatures',
  '/rh/recrutement/candidatures/:id': 'manage_candidatures',
  '/rh/recrutement/entretiens': 'plan_entretiens',
  '/rh/relations-sociales': 'authenticated',
  '/rh/remuneration-mandataires': 'view_remuneration_mandataires',
  '/rh/sante-securite': 'declarer_accident_travail',
  '/rh/tableau-de-bord': 'access_rh',
  '/rh/team-building': 'access_rh',
  '/securite/politique': 'access_politique_securite',
  '/sig/branchements': 'access_facturation_electrique',
  '/societe/associes': 'view_associes',
  '/societe/capital-social': 'view_associes',
  '/statistiques': 'access_statistics',
  '/stats-patronales': 'view_stats_patronales',
  '/stock': 'access_stock',
  '/stock/articles/:id/fiche': 'access_stock',
  '/stock/compteurs': 'access_stock',
  '/stock/demandes-sortie': 'access_demande_sortie',
  '/stock/demandes-sortie/:id': 'access_demande_sortie',
  '/stock/demandes-sortie/:id/modifier': 'edit_demande_sortie',
  '/stock/demandes-sortie/nouveau': 'create_demande_sortie',
  '/stock/disjoncteurs': 'access_stock',
  '/stock/motifs-sortie': 'gerer_motifs_sortie',
  '/stock/poteaux': 'access_stock',
  '/stock/scelles': 'access_stock',
  '/stock/transformateurs': 'access_stock',
  '/supervision': 'access_supervision',
  '/tableau-taches': 'authenticated',
  '/terrain': 'acces_releve_terrain|acces_intervention_terrain',
  '/terrain/cr': 'acces_releve_terrain|acces_intervention_terrain',
  '/terrain/cr-eau/:demandeId': 'acces_intervention_terrain',
  '/terrain/interventions': 'acces_intervention_terrain',
  '/terrain/interventions/:id': 'acces_intervention_terrain',
  '/terrain/releves': 'acces_releve_terrain',
  '/terrain/releves/:lotId': 'acces_releve_terrain',
  '/terrain/releves/:lotId/charge/:ligneId': 'acces_releve_terrain',
  '/terrain/releves/:lotId/forfait/:ligneId': 'acces_releve_terrain',
  '/terrain/releves/:lotId/saisie/:ligneId': 'acces_releve_terrain',
  '/vente-directe': 'access_caisse',
  '/vie-scolaire': 'access_vie_scolaire',
  '/vie-scolaire/annees-scolaires/:anneeId': 'access_vie_scolaire',
  '/vie-scolaire/badges': 'access_sco_badges|gerer_sco_badges|gerer_sco_badgeuses|traiter_alertes_presence',
  '/vie-scolaire/besoins-speciaux': 'access_vie_scolaire',
  '/vie-scolaire/classes/:classeId': 'access_vie_scolaire',
  '/vie-scolaire/classes/:classeId/notes/:evalId': 'access_vie_scolaire',
  '/vie-scolaire/cursus/:cursusId': 'access_vie_scolaire',
  '/vie-scolaire/cursus/:cursusId/programme': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId/abonnements-parents': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId/annees': 'access_vie_scolaire',
  '/vie-scolaire/promotions/:promotionId': 'access_vie_scolaire',
  '/vie-scolaire/promotions/:promotionId/diplomes': 'access_vie_scolaire',
  '/vie-scolaire/remises': 'access_vie_scolaire',
  // Routes ajoutées à l'intégration du travail du collègue (19/10/2026).
  '/cartes-visite': 'gerer_cartes_visite',
  '/chiffres-annuels': 'gerer_chiffres',
  '/demandes/suivi-rejets': 'access_demandes_rejetees|access_demandes_rejetees_organisation',
  '/ethique': 'gerer_ethique',
  '/instances': 'gerer_instances',
  '/opportunites': 'gerer_opportunites',
  '/parametrage': 'access_parametrage',
  '/parc-auto': 'access_parc_auto|gerer_parc_auto|saisir_plein_carburant|revoir_anomalie_carburant|reserver_vehicule_pool',
  '/pertes-non-techniques': 'access_pertes_non_techniques|access_facturation_electrique',
  '/pertes-non-techniques/detection': 'access_pertes_non_techniques|access_facturation_electrique',
  '/pertes-non-techniques/facture-fraude': 'access_pertes_non_techniques|access_facturation_electrique',
  '/programmes': 'gerer_programmes',
  '/registre-entrepreneurs': 'gerer_registre',
  '/scrutins': 'gerer_scrutins',
  '/verifications': 'gerer_verifications',
};

/** Vrai si l'utilisateur detient le droit (ou l'un des droits 'a|b') exige par la route. */
export const aDroitRoute = (requise: string, hasPermission: (p: string) => boolean): boolean =>
  requise.split('|').some((p) => hasPermission(p));
